import React, { ReactNode } from 'react';

import ProcessDialogContent from './ProcessDialogContent';
import ProcessDialogFooter from './ProcessDialogFooter';
import ProcessDialogHeader from './ProcessDialogHeader';
import { ProcessDialogSimple } from './ProcessDialogLayouts';
import ProcessDialogRoot, { ProcessDialogRootProps } from './ProcessDialogRoot';

export type { ProcessDialogContentProps } from './ProcessDialogContent';
export type { ProcessDialogHeaderProps } from './ProcessDialogHeader';
export type { ProcessDialogSimpleProps } from './ProcessDialogLayouts';
export type { ProcessDialogRootProps } from './ProcessDialogRoot';
export type { ProcessDialogAction, ProcessDialogContentVariant } from './types';
export { PROCESS_DIALOG_CONTENT_PADDING } from './types';
export {
  ProcessDialogContent,
  ProcessDialogFooter,
  ProcessDialogHeader,
  ProcessDialogSimple,
};

export interface ProcessDialogProps extends ProcessDialogRootProps {
  children: ReactNode;
}

const ProcessDialogRootComponent: React.FC<ProcessDialogProps> = ({
  open,
  onClose,
  children,
}) => {
  return (
    <ProcessDialogRoot open={open} onClose={onClose}>
      {children}
    </ProcessDialogRoot>
  );
};

const ProcessDialog = Object.assign(ProcessDialogRootComponent, {
  Header: ProcessDialogHeader,
  Content: ProcessDialogContent,
  Footer: ProcessDialogFooter,
  Simple: ProcessDialogSimple,
});

export default ProcessDialog;
